import React from 'react'
import { connect } from 'react-redux'
import { incomeChanged } from '../../../actions'
import { getIncome } from '../../../reducers'

import PAYG from './IncomeSource/IncomeTypes/PAYG'
import SelfEmployed from './IncomeSource/IncomeTypes/SelfEmployed'
import Rent from './IncomeSource/IncomeTypes/Rent'
import Shares from './IncomeSource/IncomeTypes/Shares'
import ChildMaintenance from './IncomeSource/IncomeTypes/ChildMaintenance'
import SocialSecurity from './IncomeSource/IncomeTypes/SocialSecurity'

class Income extends React.Component {
  getAttributeFromOption(attribute) {
    const { availableIncomes, income } = this.props
    return availableIncomes[income.option][attribute]
  }

  onChange = (params) => {
    let { income, currentApplicant } = this.props
    this.props.incomeChanged({
      ...{ key: income.key, currentApplicant },
      ...params
    })
  }

  renderForm() {
    const { income, errors, currentApplicant } = this.props
    const { incomeType } = income

    switch(incomeType) {
      case 'Incomes::Rent':
        return(
          <Rent income={ income }
                errors={ errors }
                onChange = { this.onChange }
                title={ this.getAttributeFromOption('title') }
                iconName={ this.getAttributeFromOption('icon_name') }
          />
        )
      case 'Incomes::Payg':
        return(
          <PAYG income={ income }
                currentApplicant={currentApplicant}
                errors={ errors }
                showEmployerType={ false }
                onChange={ this.onChange }
                title={ this.getAttributeFromOption('title') }
                iconName={ this.getAttributeFromOption('icon_name')}
                isNested={ true }
          />
        )
      case 'Incomes::SelfEmployed':
        return(
          <SelfEmployed income={ income }
                        errors={ errors }
                        onChange={ this.onChange }
                        title={ this.getAttributeFromOption('title') }
                        iconName={ this.getAttributeFromOption('icon_name') }
                        isNested={ true }
          />
        )
      case 'Incomes::ChildMaintenance':
        return(
          <ChildMaintenance income={ income }
                            errors={ errors }
                            onChange={ this.onChange }
                            title={ this.getAttributeFromOption('title') }
                            iconName={ this.getAttributeFromOption('icon_name') } />
        )
      case 'Incomes::SocialSecurity':
        return(
          <SocialSecurity income={ income }
                          errors={ errors }
                          onChange={ this.onChange }
                          title={ this.getAttributeFromOption('title') }
                          iconName={ this.getAttributeFromOption('icon_name') } />
        )
      case 'Incomes::Shares':
        return(
          <Shares income={ income }
                  errors={ errors }
                  onChange={ this.onChange }
                  title={ this.getAttributeFromOption('title') }
                  iconName={ this.getAttributeFromOption('icon_name') } />
        )
      default:
        return(
          <span>default</span>
        )
    }
  }

  render() {
    const { _destroy } = this.props.income;

    // Let's hide this if it's marked for destruction!
    if (_destroy) {
      return(null)
    }

    return(
      <div>
        { this.renderForm() }

        <div className='text-right'>
          <div
            className='pointer smaller grey mb-3'
            onClick={ () => { this.onChange({'_destroy': 1}) } }
          >
            Remove
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    income: getIncome(state, ownProps),
  }
}

export default connect(mapStateToProps, {
  incomeChanged
})(Income);
